import React, { useState } from "react";

import {
  Create,
  SaveButton,
  SimpleForm,
  Toolbar,
  TopToolbar,
  useNotify,
} from "react-admin";

import { BackButton } from "../../../components/common/BackButton";
import { ForceTitle } from "../../../components/common/ForceTitle";
import { deepRedirect, getBackPath } from "../../../utils/utils";
import { AssetTypeForm } from "./AssetTypeForm";
import { logError } from "../../../utils/appUtils";

const CreateActions = (props) => {
  const { backPath } = props;
  return (
    <TopToolbar>
      <BackButton {...props} backPath={backPath} />
    </TopToolbar>
  );
};

const CreateToolbar = (props) => (
  <Toolbar {...props}>
    <CreateSaveButton {...props} />
  </Toolbar>
);

export const AssetTypeCreate = (props) => {
  const { history } = props;
  const backPath = getBackPath(props);

  const initValues = {
    active: "true",
    groups: window.appUser.reloadYard.groups,
    reloadYardId: window.appUser.reloadYardId,
    areaId: "",
    maxConcurrentBookings: 1,
  };

  return (
    <Create
      {...props}
      title={<ForceTitle title="New Asset Type" />}
      actions={<CreateActions backPath={backPath} history={history} />}
    >
      <SimpleForm
        variant="outlined"
        submitOnEnter={false}
        initialValues={initValues}
        toolbar={
          <CreateToolbar {...props} backPath={backPath} history={history} />
        }
      >
        <AssetTypeForm {...props} />
      </SimpleForm>
    </Create>
  );
};

export const CreateSaveButton = (props) => {
  const notify = useNotify();
  const [saving, setSaving] = useState(false);
  const { backPath, history } = props;

  const onSuccess = ({ data }) => {
    debugger;
    notify(`Asset created successfully.`);
    setSaving(false);
    deepRedirect(history, backPath);
  };

  const onFailure = (error) => {
    setSaving(false);
    logError("assetTypes:AssetTypeCreate:onFailure", error, notify);
  };

  return (
    <SaveButton
      {...props}
      label="Save"
      disabled={saving}
      submitOnEnter={false}
      undoable={false}
      onSuccess={onSuccess}
      onFailure={onFailure}
    />
  );
};
